import { render, staticRenderFns } from "./GroupsFilterDropdown.vue?vue&type=template&id=517a2570&"
import script from "./GroupsFilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./GroupsFilterDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports